{
    "webshop_offer_voucher_correctCode": "Korrekt kode indtastet",
    "webShop_howToFindId_desc": "Du kan finde og kopiere dit personlige ID under din spillerprofil.",
    "webShop_howToFindId_link": "Hvor finder jeg mit personlige ID?",
    "webshop_offer_voucher_codeIsIncorrect": "Koden er forkert",
    "webshop_offer_voucher_enterYourCode": "Indtast dit personlige ID",
    "webShop_unexpectedError_desc": "Der opstod en uventet fejl. Prøv igen senere.",
    "webShop_accountBanned_desc": "Konto spærret!",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "Brugsbetingelser",
    "webshop_purchase_privacyPolicy": "Fortrolighedspolitik",
    "webshop_legal_1": "Juridisk",
    "webshop_support_1": "Support",
    "mbs_access_welcome_desc": "Velkommen, {0}",
    "btn_login": "Log ind",
    "mbs_access_error_sessionExpired_desc": "Din session er udløbet. Indtast dit konto-ID manuelt."
}
